import { render } from "./AdminGlobal.vue?vue&type=template&id=254fb876&scoped=true&ts=true"
import script from "./AdminGlobal.vue?vue&type=script&lang=ts"
export * from "./AdminGlobal.vue?vue&type=script&lang=ts"

import "./AdminGlobal.vue?vue&type=style&index=0&id=254fb876&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254fb876"]])

export default __exports__